import type { ReactNode } from "react"
import { createContext, useContext } from "react"

const DocsHeaderTabsContext = createContext<ReactNode>(null)

/** The docs screen hands its tabs to whichever right-pane header is showing. */
export const DocsHeaderTabsProvider = DocsHeaderTabsContext.Provider

/**
 * The tabs' place in a right-pane header: the left side, up to the header's own
 * buttons. Laid out with them, so a long row of tabs can never run underneath.
 */
export function DocsHeaderTabs() {
	const tabs = useContext(DocsHeaderTabsContext)
	if (!tabs) return null
	// -ml-2 puts the first tab's text, not its fill, on the header's inset.
	// A phone shows the tabs above the nav instead.
	return (
		<div className="-ml-2 mr-auto flex min-w-0 flex-1 items-center max-sm:hidden">
			{tabs}
		</div>
	)
}
